import { logError } from '@gp/base'
import * as Sentry from '@sentry/react'

export const initSentry = () => {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    tracesSampleRate: 1.0,
    integrations: [Sentry.browserTracingIntegration()],
    environment: import.meta.env.VITE_ENV_NAME,
    enabled: import.meta.env.VITE_ENV_NAME !== 'dev',
  })

  initResourcesTracking()
}

function initResourcesTracking() {
  document.body.addEventListener(
    'error',
    (event) => {
      if (!event.target) return

      const target = event.target as HTMLElement

      if (target.tagName === 'LINK') {
        logError({
          error: new Error(
            `Failed to load css: ${(target as HTMLLinkElement).href}`,
          ),
        })
      }

      if (target.tagName === 'SCRIPT') {
        logError({
          error: new Error(
            `Failed to load script: ${(target as HTMLScriptElement).src})`,
          ),
        })
      }
    },
    true, // useCapture - necessary for resource loading errors
  )
}
